var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9999 1.375C7.79587 1.38003 5.19832 3.97348 5.18823 7.1775C5.22313 7.85448 5.34956 8.52362 5.56407 9.16667C6.91157 12.6042 10.8624 20.3958 10.9999 20.625C11.1374 20.3683 15.1066 12.6042 16.4357 9.20333C16.6502 8.56029 16.7767 7.89115 16.8116 7.21417C16.8164 5.6688 16.2066 4.18492 15.1164 3.0896C14.0263 1.99428 12.5453 1.37743 10.9999 1.375ZM10.9999 8.83667C10.1012 8.83661 9.37168 8.10978 9.36835 7.21104C9.36502 6.3123 10.0891 5.58009 10.9878 5.57338C11.8865 5.56667 12.6215 6.28798 12.6316 7.18667C12.6365 7.62258 12.4667 8.04233 12.1602 8.3523C11.8537 8.66227 11.4358 8.83669 10.9999 8.83667Z",
    fill: "#E71316"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.3368d9b8ddc136db2befe2c9cc6d1729.svg";
export { ForwardRef as ReactComponent };